import React from "react";
import themeLarge from "./ThemeLarge";
import { FaGithub, FaLinkedin } from "react-icons/fa";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    const funnySignatures = [
      "Coded with snacks and dreams - ",
      "Delivered fresh from the keyboard by ",
      "100% caffeine-powered by ",
      "Made with zero bugs (hopefully) - ",
      "Internet sorcery in action by ",
      "Handcrafted in a secret lab by ",
      "Blessed by the bug gods - ",
      "Brought to you after 37 coffee breaks - ",
      "Built during a productive procrastination session - ",
      "Assembled with love and duct tape - ",
      "Straight from an overthinking brain - ",
      "Another masterpiece? Maybe! - ",
      "Proudly overengineered by ",
      "Typed with slightly tired fingers - ",
    ];
    this.state = {
      tag: "",
      last_update: "",
      isMobile: window.innerWidth <= 768,
      randomSignature:
        funnySignatures[Math.floor(Math.random() * funnySignatures.length)],
    };
  }

  // This function will update windowSize in the state whenever the window is resized
  updateWindowSize = () => {
    this.setState({
      isMobile: window.innerWidth <= 768,
    });
  };

  componentDidMount() {
    this.fetchGitTag();
    this.updateWindowSize();
  }

  fetchGitTag = () => {
    const localData = require("../version.json");
    const commitDate = new Date(localData.lastCommit.date);
    const timeAgo = this.getTimeAgo(commitDate);
    this.setState({
      tag: localData.tag,
      last_update: timeAgo,
    });
  };

  getTimeAgo = (date) => {
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 120) return "Just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)} minute(s) ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)} hour(s) ago`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)} day(s) ago`;
    if (seconds < 2592000) return `${Math.floor(seconds / 604800)} week(s) ago`;
    if (seconds < 31536000)
      return `${Math.floor(seconds / 2592000)} month(s) ago`;
    return `${Math.floor(seconds / 31536000)} year(s) ago`;
  };

  render() {
    return (
      <div
        className="row d-flex justify-content-center"
        style={{
          paddingTop: "15px",
          paddingBottom: "15px",
          fontFamily: "Kumbh Sans",
          position: "relative",
        }}
      >
        {!this.state.isMobile && (
          <div className="col-md-3">
            <small style={{ color: "#000", fontSize: "9px" }}>
              {this.state.tag}, Last updated {this.state.last_update}
            </small>
          </div>
        )}

        <div className="col-md-4 d-flex flex-column align-items-center justify-content-center text-center">
          <p
            style={{
              color: themeLarge.colors.text,
              paddingTop: "5px",
              fontSize: themeLarge.fontSize.small,
              marginBottom: this.state.isMobile ? "5px" : "0",
            }}
          >
            {this.state.randomSignature}
            <a
              href="https://www.linkedin.com/in/ibtehaz/"
              style={{ color: themeLarge.colors.text }}
              target="_blank"
              rel="noreferrer"
            >
              Ibtehaz
            </a>
          </p>

          {this.state.isMobile && (
            <a
              href="https://github.com/shepherd-06"
              target="_blank"
              rel="noreferrer"
              style={{ marginTop: "5px" }}
            >
              <FaGithub size={20} style={{ color: themeLarge.colors.text }} />
            </a>
          )}
        </div>

        {!this.state.isMobile && (
          <div
            className="col-md-3 d-flex justify-content-end align-items-center"
            style={{ paddingRight: "20px" }}
          >
            <a
              style={{
                paddingRight: "5px",
              }}
              href="https://github.com/shepherd-06"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub size={20} style={{ color: themeLarge.colors.text }} />
            </a>

            <a
              style={{
                paddingLeft: "5px",
              }}
              href="https://www.linkedin.com/in/ibtehaz/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin size={20} style={{ color: themeLarge.colors.text }} />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default Footer;
